/* eslint-disable @typescript-eslint/no-unused-vars */
import { Link } from "react-router-dom";
import "../style/css/error.css"



function Error() {
  return (
    <>
      <main>

        <section className="error">

          <p className="error__code"> 404 </p>
          
          <p className="error__txt"> Oups! La page que vous demandez n'existe pas.</p>

          <div className="error__link">

            <Link to="/dashboard" className="error__link__l" id="errora">
              Retourner sur la page d'accueil{" "}
            </Link>       
            
          </div>

        </section>
        
      </main>
    </>
  );
}
export default Error;